import { JobRequestFormKind } from './enum';
import { JobviewJob } from 'types';
import { ToggleButtonCurrentlySelected } from 'sharedComponents/Buttons/types';

export interface ApprovalFormProps {
  action: RequestApprovalAction;
  currentlySelectedToggle: ToggleButtonCurrentlySelected;
  onCreateSubmit?: (title: string, templateId?: number) => void;
  hasPendingMutation: boolean;
  onApprovalClick: () => void;
  onMergeSubmit?: (jobToMergeInto: JobviewJob) => void;
  onInnerFormClose: () => void;
  onToggle: () => void;
}

export interface ApprovalFormProps {
  onApprovalClick: () => void;
  onInnerFormClose: () => void;
}

export interface CTAButtonsProps {
  isLoading: boolean;
  onApproveClick: () => void;
  onDenyClick: () => void;
}

export interface DenialFormProps {
  currentlySelectedToggle: ToggleButtonCurrentlySelected;
  action: RequestDenialAction;
  hasPendingMutation: boolean;
  onDenialSubmit: (noteText?: string) => void;
  onInnerFormClose: () => void;
  onToggle: () => void;
}

export interface JobRequestDetailsProps {
  id: number;
  requester: string;
}

const jobRequestActionsByFormKind = {
  denial: ['return', 'archive'],
  approval: ['create', 'merge'],
} as const;

export type RequestDenialAction = (typeof jobRequestActionsByFormKind)['denial'][number];
export type RequestApprovalAction = (typeof jobRequestActionsByFormKind)['approval'][number];
export type AnyRequestFormAction = RequestDenialAction | RequestApprovalAction;

export const JobRequestModalOpeningOrigin = {
  TABBED_JOB_VIEW: 'tabbedJobView',
  JOBS_LIST: 'jobsList',
} as const;

export type JobRequestOrigin =
  (typeof JobRequestModalOpeningOrigin)[keyof typeof JobRequestModalOpeningOrigin];

export interface JobRequestModalProps {
  handleSetErrorToast: () => void;
  filterRequestFromJobsList?: (id: number) => void;
  isJobRequestModalOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  origin: JobRequestOrigin;
  requester: string;
  resetFilters?: () => void;
  role: JobviewJob;
  updateRoleStatusOnJobsList?: (roleId: number, status: number) => void;
  initialAction: AnyRequestFormAction | undefined;
}

export interface MergeSubFormProps {
  hasComboboxError: boolean;
}

export interface BaseRequestState<T extends JobRequestFormKind> {
  kind: T;
  toggleId: ToggleButtonCurrentlySelected;
}

export interface RequestDenialState extends BaseRequestState<JobRequestFormKind.denial> {
  requestDenialAction: RequestDenialAction;
}

export interface RequestApprovalState extends BaseRequestState<JobRequestFormKind.approval> {
  requestApprovalAction: RequestApprovalAction;
}

export type RequestState = RequestDenialState | RequestApprovalState;

export type RequestStateKind = RequestState['kind'];

export interface SuccessMessagingProps {
  jobId?: number;
  jobTitle?: string;
  message: string;
  shouldShowSecondButton: boolean;
  onClose: () => void;
  origin: JobRequestOrigin;
}

type CreateFormFields = {
  title: string;
  template: JobviewJob;
};

type MergeFormFields = {
  jobToMergeInto: JobviewJob;
};

export type FormFields = CreateFormFields | MergeFormFields;
